import { Component, Input } from '@angular/core';
import {
	CONNECTION_TYPE,
	DOCS_TYPE,
	IConnectionOperation,
	IDocumentsOperation,
	IOperation,
	OPERATION_TYPE,
} from '../../../../../../operations/models/operations.models';
import {
	BadgeComponent,
	CardSelectComponent,
	CollapseComponent,
	InfoGroupComponent,
	TileComponent,
} from '@tecalisdev/infinity';
import { TranslatePipe } from '@ngx-translate/core';
import { UpperCasePipe } from '@angular/common';
import { DeveloperCurlButtonComponent } from '../../../../../../shared/components/developer-curl-button/developer-curl-button.component';

@Component({
	selector: 'app-attorney-powers-operation',
	imports: [
		CollapseComponent,
		TranslatePipe,
		TileComponent,
		CardSelectComponent,
		UpperCasePipe,
		InfoGroupComponent,
		BadgeComponent,
		DeveloperCurlButtonComponent,
	],
	templateUrl: './attorney-powers-operation.component.html',
	styleUrl: './attorney-powers-operation.component.scss',
})
export class AttorneyPowersOperationComponent {
	@Input() operation?: IDocumentsOperation | IConnectionOperation;
	@Input() operations?: Array<IOperation>;
	@Input() index: number = 1;
	@Input() profileUuid?: string;

	public CONNECTION_TYPE: typeof CONNECTION_TYPE = CONNECTION_TYPE;
	public DOCS_TYPE: typeof DOCS_TYPE = DOCS_TYPE;
	public OPERATION_TYPE: typeof OPERATION_TYPE = OPERATION_TYPE;

	public operationCurlPath(): string {
		if (!this.profileUuid || !this.operation?.uuid) return '';
		return `/profile/${this.profileUuid}/operations/${this.operation.uuid}`;
	}
}
